import T from 'i18n-react';
import { PAGE_SETTINGS_PATH } from 'helpers/constants/store';

/* eslint-disable import/prefer-default-export */
export const JOB_TYPE_DROPDOWN = [
  {
    value: 'document_review',
    label: T.translate('module_desktop_review.common.documentReview'),
  },

  {
    value: 'walmart_document_review',
    label: T.translate('module_desktop_review.common.walmartCPCGCCSubmission'),
  },
  // {
  //   value: 'cpc_preparation',
  //   label: 'CPC_PREPARATION'
  // },
  // {
  //   value: 'doc_preparation',
  //   label: 'DOC_PREPARATION'
  // },
  // {
  //   value: 'technical_inquire',
  //   label: 'TECHNICAL_INQUIRE'
  // },
  // {
  //   value: 'test_plan',
  //   label: 'TEST_PLAN'
  // },
];
// REf :https://www.notion.so/icw-io/QMAS-Document-Review-Overall-QA-Enhancement-6-74fc1b83b7714309aaee9eaf1606591c?pvs=4#1f325025175c46a7870923c202c650d4
export const RESULT_DROPDOWN = [
  {
    value: 'pending',
    label: T.translate('general.pending'),
  },
  // {
  //   value: 'inProgress',
  //   label: T.translate('status.inProgress'),
  // },
  {
    value: 'approve',
    label: T.translate('status.approve'),
    color: 'green',
  },
  {
    value: 'reject',
    label: T.translate('status.reject'),
    color: 'red',
  },
  {
    value: 'waitingInformation',
    label: T.translate('status.waitingInformation'),
    color: 'orange',
  },
  {
    value: 'n/a',
    label: T.translate('general.na'),
  },
];

/**
 * ref: https://www.notion.so/icw-io/QMAS-Document-Review-QA-QMAS-LabCOMS-7ce66dd8028943f08023dc32269df1f5?pvs=4#d5510ce6b9a74cc8b40365265a7a7fc8
 */
export const STATUS_DROPDOWN = [
  {
    value: 'draft',
    label: T.translate('status.draft'),
  },
  {
    value: 'pendingPayment',
    label: T.translate('status.pendingPayment'),
  },
  {
    value: 'beingProcess',
    label: T.translate('status.beingProcess'),
  },
  // {
  //   value: "underReview",
  //   label: "Pending Under Review"
  // },
  {
    value: 'waitingForStartReview',
    label: T.translate('status.waitingForStartReview'),
  },
  {
    value: 'waitingForUpload',
    label: T.translate('status.waitingForUpload'),
  },
  {
    value: 'quoteAvailable',
    label: T.translate('status.quoteAvailable'),
  },
  {
    value: 'waitingForFinalQuote',
    label: T.translate('status.waitingForFinalQuote'),
  },
  {
    value: 'finalQuoteAvailable',
    label: T.translate('status.finalQuoteAvailable'),
  },
  {
    value: 'in-progress',
    label: T.translate('status.inProgress'),
  },
  {
    value: 'onHold',
    label: T.translate('status.onHold'),
  },
  {
    value: 'reviewed',
    label: T.translate('status.reviewed'),
  },
  {
    value: 'completed',
    label: T.translate('status.completed'),
  },
  {
    value: 'cancelled',
    label: T.translate('status.cancelled'),
  },
];

export const TAB_KEYS = {
  MY_JOB: 'my_job',
  PARTNER_JOB: 'partner_job',
  ALL_JOB: 'all_job',
  VIEW_ONLY: 'view_only',
};
export const TAB_PAGE_SETTINGS_PATH = {
  [TAB_KEYS.ALL_JOB]: PAGE_SETTINGS_PATH.DOCUMENT_REVIEW_ALL,
  [TAB_KEYS.MY_JOB]: PAGE_SETTINGS_PATH.DOCUMENT_REVIEW_MY_JOB,
  [TAB_KEYS.VIEW_ONLY]: PAGE_SETTINGS_PATH.DOCUMENT_REVIEW_VIEW_ONLY,
};
export const DEFAULT_FILTERS = {
  [TAB_KEYS.ALL_JOB]: {
    jobType: [],
    status: [],
    updatedAt: {
      field: ['updatedAt'],
      method: ['az'],
      dates: [],
    },
    categories: [],
  },
  [TAB_KEYS.MY_JOB]: {
    jobType: [],
    status: [],
    updatedAt: {
      field: ['updatedAt'],
      method: ['az'],
      dates: [],
    },
    categories: [],
  },
  [TAB_KEYS.VIEW_ONLY]: {
    jobType: [],
    status: [],
    updatedAt: {
      field: ['updatedAt'],
      method: ['az'],
      dates: [],
    },
    categories: [],
  },
};
export const fieldItems = [
  {
    value: 'updatedAt',
    label: 'Updated Date',
  },
  {
    value: 'ecd',
    label: 'ECD',
  },
];
export const methodItems = [
  {
    value: 'az',
    label: T.translate('general.newestToOldest'),
  },
  {
    value: 'za',
    label: T.translate('general.oldestToNewest'),
  },
];
export const ratingItems = [
  {
    value: 'za',
    label: 'High to Low',
  },
  {
    value: 'az',
    label: 'Low to High',
  },
];
